<template>
    <div class="recharge_left capital_first">
      <el-card class="box-card" shadow="never">
        <div slot="header" class="clearfix">
          <div v-if="!couponCheck" class="content_title"><h3>{{$t('agencyPc.agencyAccount')}}</h3></div>
          <div v-if="couponCheck" class="content_title"><h3>{{$t('agencyPc.friendCashCoupon')}}</h3></div>
        </div>
        <el-tabs id="agencyTabs">
          <el-tab-pane style="margin-left: 20px">
            <h4 slot="label">{{$t('agencyPc.myPromotion')}}</h4>
            <div>
              <p v-if="!couponCheck">{{$t('agencyPc.scanToRegister')}}</p>
              <p v-if="couponCheck">{{$t('agencyPc.inviteFriendsToRegister')}}</p>
              <p v-if="couponCheck">
                {{$t('agencyPc.friendGift', {couponAmountMultiplied: couponAmount * 10,amount: couponAmount })}}
              </p>
              <p v-if="couponCheck">
                {{$t('agencyPc.afterAllocationFunds')}} {{(couponAmount + (couponAmount * 10))*10}} {{ $t('agencyPc.withdrawnCurrency') }}
              </p>
  
              <div v-if="couponCheck"><br /></div>
              <p v-if="couponCheck">{{$t('agencyPc.inviteFriendsToRegister')}}</p>
  
              <div id="qrcode" class="agency_qrcode"></div>
            </div>
            <div>
              <h4 v-if="couponCheck">{{$t('agencyPc.couponNumberPerPerson', {number: couponNo})}}</h4>
              <br />
            </div>
  
            <div v-if="!couponCheck">
              <h4>{{$t('aaagencyPc.methodTwo')}}</h4>
              <p style="margin-top: 10px">
                {{ friendUrl
                }}<el-button
                  type="danger"
                  size="mini"
                  @click="handleCopy(friendUrl)"
                  style="
                    color: var(--baseColor);
                    background: transparent;
                    border-color: var(--baseColor);
                    margin-left: 10px;
                  "
                  >{{$t('agencyPc.copyLink')}}</el-button
                >
              </p>
            </div>
            <div v-if="couponCheck">
              <h4>{{$t('agencyPc.methodTwo')}}</h4>
              <p style="margin-top: 10px">
                {{ agencyUrlSub
                }}<el-button
                  type="danger"
                  size="mini"
                  @click="handleCopy(agencyUrlSub)"
                  style="
                    color: var(--baseColor);
                    background: transparent;
                    border-color: var(--baseColor);
                    margin-left: 10px;
                  "
                  >{{$t('agencyPc.copyLink')}}</el-button
                >
              </p>
            </div>
  
            <div v-if="!couponCheck" style="margin-top: 20px">
              <h4>{{$t('agencyPc.methodThree')}}</h4>
            </div>
            <div v-if="couponCheck" style="margin-top: 20px">
              <h4>{{$t('agencyPc.methodThree')}}</h4>
              <p style="margin-top: 10px">
                {{ couponNo
                }}<el-button
                  type="danger"
                  size="mini"
                  @click="handleCopy(couponNo)"
                  style="
                    color: var(--baseColor);
                    background: transparent;
                    border-color: var(--baseColor);
                    margin-left: 10px;
                  "
                  >{{$t('agencyPc.copyLink')}}</el-button
                >
              </p>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>
    </div>
  </template>
  
  <script>
    import QRCode from 'qrcodejs2'
      export default {
          name: "FriendCouponQR",
        data(){
          return{
            friendUrl:'',
            agencyUrlSub: '',
            code:'',
            //管理费
            manageData: [],
            commissionDetails: [],
            withdrawData:[],
            voucherData:[],
            //递延费
            deferredData:[],
            //利润分成
            dividedData:[],
            //我的会员
            teamData:[],
            //充值会员,
            rechargeTeamData:[],
            //无充值会员
            noRechargeTeamData:[],
            //一级会员
            levelOne:0,
            //二级会员
            levelTwo:0,
            //三级会员
            levelThree:0,
            //今日会员
            todayNum:0,
            //代理佣金
            agent_account:0,
            cash:0,
            //对话框佣金提现状态
            withdrawState:false,
            //对话框佣金划转状态
            transferState:false,
            //银行卡管理状态
            bankCardState:false,
            //提现
            withdrawalData:{
              name:'',
              card:'',
              address:'',
              account:'',
              money:'',
              password:''
            },
            //划转
            transferData:{
              number:''
            },
            formLabelWidth:'120px',
            //银行卡列表
            bankCardList:[],
            couponAmount: "",
            couponNo: "",
            couponCheck : false,
            subUrl: "",
            isFromCoupon: false,
            wit_total:0,
            manage_total:0,
            deferred_total:0,
            divide_total:0,
            average_depot_people: [],
            average_depot_month: Date.now(),
            total_depot_users: 0,
            avarage_depot_users: 0,
            total_days: 0,
          }
        },
        computed:{
        },
        methods: {
          getCode() {
            let that = this;
            that.code = sessionStorage.getItem("friendQrcode");
          },
          qrcode(url) {
            console.log('qqqq',url);
            let qrcode = new QRCode('qrcode', {
              width: 200,
              height: 200,
              text: url, // 二维码地址
            })
          },
          getFriendUrl(){
  
            let that = this;
            that
              .$http({
                url: "/app/FriendCoupon/coupon_url",
                method: "post",
                data: {}
              })
              .then(function (res) {
                let resData = res.data;
                if (res.data.status == 200) {
                  that.friendUrl = resData.data[0].popup;
                  sessionStorage.setItem("qrcodeUrl",that.friendUrl);
                  var subUrl = sessionStorage.getItem("qrcodeUrl");
                  that.$store.commit("qrCodeUrl", subUrl);
                  that.subUrlMethod();
                  that.qrcode(that.friendUrl);
                  that.getCode();
                } else {
                  that.$message.error(that.$t(res.data.msgId));
                }
              });
          },
          subUrlMethod(){
            let that = this;
            that.subUrl = that.$store.state.qrCodeUrl;
            // if(that.$store.state.couponNo) {
              that.couponCheck = true;
              that.agencyUrlSub = that.subUrl.split('=')[0]
              that.agencyUrlSub = that.agencyUrlSub + "=";
              that.agencyUrl = that.agencyUrlSub.concat(sessionStorage.getItem("friendQrcode"));
              that.agencyUrlSub = that.agencyUrl;
            // }
        },
          //复制
          handleCopy(copy){
            let text = copy;
            let oInput = document.createElement('input');
            oInput.value = text;
            document.body.appendChild(oInput);
            oInput.select();
            document.execCommand("Copy");
            this.$message({
              message: this.$t('agencyPc.copySuccess'),
              type: 'success'
            });
            oInput.remove()
          },
        },
        // created() {
        //   this.couponAmount = this.$store.state.couponAmount;
        //   this.couponNo = this.$store.state.couponNo;
        //   console.log('EEEEEEEEE',this.$store.state.couponNo);
        // },
        mounted () {
            this.getFriendUrl();
            this.couponAmount = this.$store.state.couponAmount;
            this.couponNo = sessionStorage.getItem("friendQrcode");
        },
        // beforeDestroy() {
        //   this.$store.state.couponNo = "";
        //   this.$store.state.couponAmount = "";
        //   // console.log('RTRRRRRRR',this.$store.state.couponNo);
        // },
      }
  </script>
  
  <style scoped>
  .agency_title {
    text-align: center;
  }
  .agency_qrcode {
    width: 200px;
    margin: 25px 0;
  }
  .weigth {
    font-weight: bold;
  }
  
  .box-card {
    border-radius: 8px;
    border: none;
    background-color: transparent;
  }
  
  .box-card >>> .el-card__header {
    background-color: #ffffff;
    border-radius: 8px;
    border: none;
    margin-bottom: 20px;
  }
  
  .box-card >>> .el-card__body {
    background-color: #ffffff;
    border-radius: 8px;
    border: none;
  }
  
  .content_title {
    /* font-size: 18px; */
    text-align: left;
  }
  
  .secondTabDetailBox {
    background: var(--baseColor);
    padding: 20px 25px;
    color: #ffffff;
    border-radius: 5px;
    display: flex;
    align-items: center;
    margin: 10px 0px 15px;
  }
  
  .secondTabDetailBox p {
    text-align: left;
  }
  #couponTabs>>>.el-tabs--card>.el-tabs__header .el-tabs__nav {
    background-color: #E9E9F0;
    border-radius: 25px;
    padding: 3px 7px;
  }
  #couponTabs>>>.el-tabs--card>.el-tabs__header {
    border: none;
    margin-bottom: 25px
  }
  .integer-value {
    font-size: 20px;
    font-weight: 500;
  }
  .decimal-value {
    font-size: 16px;
    font-weight: 500;
    margin-left: -5px;
  }
  </style>
  <style>
  #agencyTabs .el-tabs__active-bar {
    display: none;
    background-color: var(--baseColor);
  }
  
  #agencyTabs .el-tabs__item.is-active {
    color: var(--baseColor);
  }
  #agencyTabs .el-tabs__item:hover {
    color: var(--baseColor) !important;
  }
  
  #agencyTabs .el-tabs__item.is-active:after {
    height: 3px;
    display: block;
    width: auto;
    background: var(--baseColor);
    content: "";
    border-radius: 5px;
    width: 45px;
    display: block;
    margin: 0 auto;
    top: -4px;
    position: relative;
  }
  #couponTabs .el-tabs__item.is-active {
    color: #FFFFFF;
    background-color: var(--baseColor);
    border-radius: 25px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/friendcouponqr.vue